// removed by extract-text-webpack-plugin
module.exports = {"fields-container":"processing-fields__fields-container___zMAuC","fields-wrapper":"processing-fields__fields-wrapper___1UHty","section":"processing-fields__section___13uhb","save":"processing-fields__save___2AAru","trash":"processing-fields__trash___BI8JD","reprocess":"processing-fields__reprocess___38gij"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/processing-fields.scss
// module id = 326
// module chunks = 0